import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }

import { ref, computed, onMounted } from 'vue'
import { useUserStore } from '@/stores/user'
import { ProfilePoupData } from './supportScript';
import ProfilePopupOne from '@/themes/themeOne/profile/profilePopup.vue';
import ProfilePopupTwo from '@/themes/themeTwo/profile/profilePopup.vue';
import ProfilePage from '@/themes/themeThree/profile/profilePage.vue';
import { HOME_COMPONENT_ID } from '../home/supportScript';
import { useThemeStore } from '@/stores/theme';


export default /*@__PURE__*/_defineComponent({
  __name: 'profilePage',
  emits: ['openAgentPopup'],
  setup(__props, { emit: __emit }) {

const userStore = useUserStore()
const themeStore = useThemeStore();
const componentIdsInOrderConfig = ref(HOME_COMPONENT_ID);
const show = ref(false)
const isPopping = ref(false)
const componentList = ref([])

const dataSet = computed<ProfilePoupData>(() => ({
    show: show.value,
    isPopping: isPopping.value,
    componentList: componentList.value,
    componentIdsInOrderConfig: componentIdsInOrderConfig.value,
}))

onMounted((list: any) => {
    componentList.value = list
    show.value = true
    userStore.getInfo()
})
const emits = __emit
const clickBanner = () => {
    isPopping.value = true
    setTimeout(() => {
        isPopping.value = false
        emits('openAgentPopup')
    }, 300)

}


return (_ctx: any,_cache: any) => {
  return (_unref(themeStore).themeIndex === 3)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(ProfilePage, {
          "data-set": dataSet.value,
          onClickBanner: clickBanner
        }, null, 8, ["data-set"])
      ]))
    : _createCommentVNode("", true)
}
}

})